export default __webpack_public_path__ + "static/media/screen10.7c7bf72e.png";